<template lang="pug">
  .row.mp0
    .col.l12.m12.mp0( v-if="UserType")
      nav-bar-back-office
        //- h4 BACK OFFICE
      .m25  
        .col.s6()
          h4 Unidades 
          TableMinComponent( tbName="unidades" :datosValues="datosValuesUnidades" v-on:ModifyData="EmitModify")
        .col.s6()
          h4 Operadores 
          TableMinComponent( tbName="operadores_ayudantes" :datosValues="datosValuesOperadores"  v-on:ModifyData="EmitModify")
    ModalBottomComponent( :editValues="editValues" v-on:SaveElement="EmitUpdateOrAdd" :isNew="isNew" ) 
</template>
<style>
  .mp0{
    margin: 0;
    padding: 0 !important;
  }
  .m25{
    margin-left:  25px ;
    margin-right: 25px;
  }
</style>
<script>
import firebase from '../config'
import M from 'materialize-css'

import NavBarBackOffice from '../components/NavBarBackOffice.vue'
import TableMinComponent from '../components/TableMinComponent.vue'
import ModalBottomComponent from '../components/ModalBottomComponent.vue'
const { db } = firebase;
export default {
  name:"BackOfficeUnidadOperadores",
  components: { NavBarBackOffice, TableMinComponent,ModalBottomComponent },
  props:[],
  data() {
    return {
      isNew                   : false,
      UserType                : 4,
      headsNamesUnidades      : [],
      datosValuesUnidades     : [],
      headsNamesOperdores     : [],
      datosValuesOperadores   : [],
      typeForm                : 1,
      editValues              : {title : ""},
    }
  },
  methods: {
    EmitUpdateOrAdd(_Datos){
      // console.log('Recived data: ', _Datos)
      switch (_Datos.action) {
        case "update":
          // this.isNew = false;
          this.updateTbElement(_Datos);
          break;
        
        case "add-new":
          // this.isNew = 1;
          this.CreateNewItem(_Datos);
          console.log("Save action");
          break;

        default:
          break;
      }
      
    },
    CreateNewItem(_data){
      db.collection(_data._target)
      db.collection(_data._target)
      .add({ name:_data.name, descripcion:  _data.descripcion, activo: true })
      .then( (r) => this.CloseModal() )
    },
    EmitModify(_datos) { 
      // console.log("Propt: ", _datos);
      switch (_datos.action) {
        case "delete":
          this.isNew = false;
          this.deleteTbElement(_datos);
          break;

        case "edit":
          this.isNew = false;
          this.editByIndex(_datos);
          // console.log("Edit: ", _datos);
          break; 
        
        case "add-new":
          this.NewItem(_datos);
          this.isNew = true;
          // console.log("Edit: ", _datos);
          break; 

        default:
          break;
      }
    },
    NewItem (_d) {
      // console.log("Add New:", _d );
      this.editValues = {title : _d.name};
      this.openModal()
    },
    openModal(){
      let elems = document.querySelector("#modal-bottom");
      this.modal = M.Modal.init(elems, {});
      setTimeout( () => {
        this.modal.open();
      },10 );
      
    },
    CloseModal(){ this.modal.close()},
    getArrByTbName(_tb,_index){ 
      let _tmp
      switch (_tb) {
        case "unidades":
          _tmp = this.datosValuesUnidades[_index];
          _tmp.title = _tb;
          // return _tmp;
          break;
        
        case "operadores_ayudantes":
          _tmp = this.datosValuesOperadores[_index];
          _tmp.title = _tb;
          // return _tmp;
          break;      
        
        default:
          return _tmp; // que hacer si no tengo indice ? 
          break;
      }
      this.editValues = _tmp;
    },
    editByIndex(_info){
      // _elementos = 
      this.editValues = {} ;
      this.getArrByTbName(_info.name,_info.index);
      this.openModal();
    },
    updateTbElement(_data){ 
      let _modifyData = {
        name:_data.name,
        descripcion:_data.descripcion
      };
      
      db.collection(_data._target)
      .doc(_data.id).update(_modifyData)
      .then( () => this.CloseModal() );
    },
    deleteTbElement(_data){ 
      db.collection(_data.name)
      .doc(_data.id).update({"activo":false})
      .then( (_resp) => console.log(_resp));
    },
    saveUnidadesAll(_datos) {
      let _self = this;
      db.collection('unidades')
      .add(_datos)
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    },
    populateData(){
    let _tmpArrUnidades, _tmpArrOperdores;
    let _self = this;
    db.collection('unidades')
      .where('activo', '==', true)
      .onSnapshot(function(snapshot) {
        _tmpArrUnidades = [];
        snapshot.forEach(function(doc) {
          let _tpm = doc.data();
          _tpm.id  = doc.id;
          // _self.headsNamesUnidades.push(_tpm);
          _tmpArrUnidades.push(_tpm);
        }, function(error) { console.log(error); });	
        // console.log(_tmpArrUnidades);
        _self.datosValuesUnidades = _tmpArrUnidades;
      });

      db.collection('operadores_ayudantes')
        .where('activo', '==', true)
      .onSnapshot(function(snapshot) {
        _tmpArrOperdores = [];
        snapshot.forEach(function(doc) {
          let _tpm = doc.data();
          _tpm.id  = doc.id;
          // _self.headsNamesUnidades.push(_tpm);
          _tmpArrOperdores.push(_tpm);
        }, function(error) { console.log(error); });	
        _self.datosValuesOperadores = _tmpArrOperdores;
        // console.log(_tmpArrOperdores);
      });
    }
  },
  created() {
    this.populateData();
    // let _arr = ["900", "901", "903", "904", "905", "906", "907", "908", "909", "910", "911", "913", "914", "915", "Camión 36", "Camión 39", "Camión 49", "Camión 100", "Camión 146", "Grúa 916"];
    // _arr.forEach(element => {
    //   this.saveUnidadesAll({"name": element, "descripcion": "", "activo":true });
    // });
  },
  
}
</script>